import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Icon,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import moment from "moment";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  GET_LONG_QUESTIONS,
  GET_MINI_QUESTIONS,
  GET_QUIZ_PROGRESS,
} from "../_redux/dashboardCrud";

// Sub Components

import store from "../../../../redux/store";
import { questionsSlice } from "../_redux/dashboardSlice";
import { quizResultsSlice } from "../../quiz/_redux/quizSlice";

const { actions } = questionsSlice;

const { actions: quizResultsAction } = quizResultsSlice;

export function Questionnaire() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useSelector((state) => state.auth);

  const [isReady, setIsReady] = useState(!user);

  const localAnswers = localStorage.getItem("quiz-answers");

  const dataFetched = ({ questions, total }) => {
    dispatch(actions.questionsFetched({ questions, total }));
    history.push("/quiz");
  };

  if (localAnswers && localAnswers.length) {
    const localQuestions = JSON.parse(localStorage.getItem("quiz-questions"));
    dataFetched({
      questions: localQuestions,
      total: localQuestions.length,
    });
    dispatch(quizResultsAction.setAnswers({ answers: localAnswers }));
  }

  useQuery(GET_QUIZ_PROGRESS, {
    skip: !user,
    onCompleted: (res) => {
      if (res.quizProgress.isCompleted) {
        dispatch(
          quizResultsAction.setAnswers({ answers: res.quizProgress.answers })
        );
        dispatch(
          quizResultsAction.resultsFetched({
            results: res.quizProgress.results.result,
          })
        );
        history.push("/results");
      } else if (!res.quizProgress.isQuizTaken) {
        setIsReady(true);
      } else {
        dataFetched({
          questions: res.quizProgress.questions.questions,
          total: res.quizProgress.questions.total,
        });
        dispatch(
          quizResultsAction.setAnswers({ answers: res.quizProgress.answers })
        );
      }
    },
  });

  const [fetch30Question, { loading: miniFetchloading }] = useLazyQuery(
    GET_MINI_QUESTIONS,
    {
      onCompleted: (data) => {
        localStorage.setItem(
          "quiz-questions",
          JSON.stringify(data.miniQuestionsList.questions)
        );
        dataFetched({
          questions: data.miniQuestionsList.questions,
          total: data.miniQuestionsList.total,
        });
      },
    }
  );
  const [fetch60Question, { loading: longFetchloading }] = useLazyQuery(
    GET_LONG_QUESTIONS,
    {
      onCompleted: (data) => {
        localStorage.setItem(
          "quiz-questions",
          JSON.stringify(data.longQuestionsList.questions)
        );
        dataFetched({
          questions: data.longQuestionsList.questions,
          total: data.longQuestionsList.total,
        });
      },
    }
  );

  const openMiniQuiz = async () => {
    fetch30Question();
  };

  const openLongQuiz = () => {
    fetch60Question();
  };

  const {
    auth: { tokenExpiresAt },
  } = store.getState();
  if (moment().isAfter(moment(tokenExpiresAt))) {
    localStorage.clear();
  }

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        <Box
          textAlign="center"
          borderRadius={8}
          style={{ backgroundColor: "white" }}
          p={2}
          mb={1}
        >
          <Typography variant="h3">INTEREST PROFILER</Typography>
          <Typography variant="h6">
            Discover what your interests are and how they relate to the world of
            work
          </Typography>
        </Box>
      </Box>
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={12} md={7}>
            <Box
              style={{ backgroundColor: "white" }}
              borderRadius={8}
              mr={1}
              p={3}
              height="100%"
            >
              <Box m={2} textAlign="center">
                <Typography variant="h4"> Getting Started</Typography>
              </Box>
              <Box display="flex" mb={1}>
                <Box display="flex" mx={1}>
                  <Box mr={1}>
                    <i className="fa fa-clock mr-1" aria-hidden="true"></i>
                  </Box>
                  Take your time
                </Box>
                |
                <Box mx={1} display="flex">
                  <Box mr={1}>
                    <i className="fa fa-comment-dots" aria-hidden="true"></i>
                  </Box>
                  Think each question through
                </Box>
                |
                <Box ml={1} display="flex">
                  <Box mr={1}>
                    <i className="fa fa-balance-scale" aria-hidden="true"></i>
                  </Box>
                  There are no right or wrong answers
                </Box>
              </Box>
              <Box m={2}>
                <Typography variant="h6">
                  Read each question carefully and decide how you would feel
                  about doing each work activity:
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="center"
                m={2}
                textAlign="center"
                flexWrap="wrap"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mr={5}
                >
                  <Icon
                    className={clsx("fa fa-frown-open")}
                    style={{ fontSize: 50, color: "#f44336" }}
                  />
                  Strongly dislike
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mr={5}
                >
                  <Icon
                    className={clsx("fa fa-frown")}
                    style={{ fontSize: 50, color: "#ff9800" }}
                  />
                  Dislike
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mr={5}
                >
                  <Icon
                    className={clsx("fa fa-meh")}
                    style={{ fontSize: 50, color: "#fdd835" }}
                  />
                  Unsure
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mr={5}
                >
                  <Icon
                    className={clsx("fa fa-smile")}
                    style={{ fontSize: 50, color: "#8bc34a" }}
                  />
                  Like
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mr={5}
                >
                  <Icon
                    className={clsx("fa fa-grin")}
                    style={{ fontSize: 50, color: "#4caf50" }}
                  />
                  Strongly like
                </Box>
              </Box>
              <Box m={2} mt={3} fontSize={16}>
                At any point during the profiler you can change your answer to a
                question. Simply use your mouse to move to the question where
                you want to change your answer. Then select your new answer.
              </Box>
              <Box m={2} fontSize={16}>
                For best results, please answer as accurately as possible.
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              p={2}
              textAlign="center"
              style={{ backgroundColor: "white" }}
              borderRadius={8}
              height="100%"
            >
              <Typography variant="h4">Select one of the following:</Typography>
              <Box textAlign="center" border={1} borderRadius={8} m={3} p={3}>
                <Box m={1}>
                  <Typography variant="h6">Short Quiz</Typography>
                </Box>
                <Box m={2}>
                  <Typography>30 Questions</Typography>
                </Box>
                <Button
                  onClick={openMiniQuiz}
                  variant="outlined"
                  style={{
                    color: "#3699FF",

                    borderColor: "#3699FF",
                  }}
                  size="large"
                  disabled={miniFetchloading || !isReady}
                >
                  {miniFetchloading || !isReady ? (
                    <CircularProgress
                      style={{ color: "#3699FF" }}
                      color="#3699FF"
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      size={20}
                    />
                  ) : (
                    <Typography style={{ width: "40px" }}>BEGIN</Typography>
                  )}
                </Button>
              </Box>
              <Box textAlign="center" border={1} borderRadius={8} m={3} p={3}>
                <Box m={1}>
                  <Typography variant="h6"> Long Quiz</Typography>
                </Box>
                <Box m={2}>60 Questions</Box>
                <Button
                  variant="outlined"
                  style={{ color: "#3699FF", borderColor: "#3699FF" }}
                  size="large"
                  onClick={openLongQuiz}
                  disabled={miniFetchloading || !isReady}
                >
                  {longFetchloading || !isReady ? (
                    <CircularProgress
                      style={{ color: "#3699FF" }}
                      color="#3699FF"
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      size={20}
                    />
                  ) : (
                    <Typography style={{ width: "40px" }}>{"BEGIN"}</Typography>
                  )}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
